module.exports = __webpack_public_path__ + "static/media/method2.e65a2c65.png";